import isEqual from 'lodash-es/isEqual'
import uniqBy from 'lodash-es/uniqBy'

import { EMPTY_LIST, ENTITY_KEY_ID } from '../../../../../constants/common'
import { STATUS_FILTER_NAME } from '../../../../../constants/filter'
import { PAGE_DEFAULT_VALUE } from '../../../../../constants/route'
import { getItemsIds } from '../../../../../utils/common'
import {
  REQUEST_BOARD_COLUMN_FIRST_INDEX,
  REQUEST_BOARD_COLUMN_PAGE_SIZE,
} from '../../RequestBoard.constants'

function isRequestBoardColumnItem({ item, status }) {
  return item?.status === status
}

function replaceRequestBoardColumnItem({ item, items }) {
  return items.map(columnItem =>
    columnItem.id === item.id ? item : columnItem
  )
}

export function getRequestBoardColumnFilters({ filterValues, status }) {
  return { ...filterValues, [STATUS_FILTER_NAME]: [status] }
}

export function isRequestBoardColumnExcluded({ filterValues, status }) {
  const statuses = filterValues?.[STATUS_FILTER_NAME] ?? EMPTY_LIST

  return statuses.length > 0 && !statuses.includes(status)
}

// A filter change that keeps the column's own filters (a status-only change, a
// re-applied template) reloads nothing.
export function isRequestBoardColumnUpdateNeeded({
  filters,
  isListHidden,
  listFilters,
}) {
  return isListHidden || !isEqual(filters, listFilters)
}

export function isRequestBoardColumnListStale({
  filters,
  isListHidden,
  listFilters,
}) {
  return isListHidden && isEqual(filters, listFilters)
}

export function isRequestBoardColumnReloaded([items, isCountLoaded]) {
  return Boolean(items) && isCountLoaded
}

export function isRequestBoardColumnCountCurrent({ countFilters, filters }) {
  return isEqual(countFilters, filters)
}

export function getRequestBoardColumnFirstPageParams() {
  return { page: PAGE_DEFAULT_VALUE }
}

export function getRequestBoardColumnNextPageParams({ items, pageOffset }) {
  return {
    page:
      Math.floor(items.length / REQUEST_BOARD_COLUMN_PAGE_SIZE) +
      PAGE_DEFAULT_VALUE +
      pageOffset,
  }
}

export function isRequestBoardColumnPageExhausted({ items, pageItems }) {
  const ids = getItemsIds(items)

  return (
    pageItems.length === REQUEST_BOARD_COLUMN_PAGE_SIZE &&
    pageItems.every(item => ids.includes(item.id))
  )
}

export function checkRequestBoardColumnIsLastPage(response, getDataItems) {
  return getDataItems(response).length < REQUEST_BOARD_COLUMN_PAGE_SIZE
}

export function mergeRequestBoardColumnItems(prevItems, nextItems) {
  return uniqBy([...prevItems, ...nextItems], ENTITY_KEY_ID)
}

export function getRequestBoardColumnVisibleItems({ departedIds, items }) {
  return items.filter(item => !departedIds.includes(item.id))
}

export function isRequestBoardColumnLoadMorePaused({
  departedIds,
  insertedIds,
}) {
  return departedIds.length > 0 || insertedIds.length > 0
}

export function insertRequestBoardColumnItem({ index, item, items }) {
  return getItemsIds(items).includes(item.id)
    ? items
    : [...items.slice(0, index), item, ...items.slice(index)]
}

export function removeRequestBoardColumnItem({ id, items }) {
  return items.filter(item => item.id !== id)
}

export function updateRequestBoardColumnItem({ item, items, status }) {
  return replaceRequestBoardColumnItem({ item: { ...item, status }, items })
}

// The card counts in the column after the sync minus before it.
export function getRequestBoardColumnSyncCountChange({
  id,
  item,
  items,
  status,
}) {
  return (
    Number(isRequestBoardColumnItem({ item, status })) -
    Number(getItemsIds(items).includes(id))
  )
}

export function syncRequestBoardColumnItem({ id, item, items, status }) {
  return isRequestBoardColumnItem({ item, status })
    ? getItemsIds(items).includes(id)
      ? replaceRequestBoardColumnItem({ item, items })
      : insertRequestBoardColumnItem({
          index: REQUEST_BOARD_COLUMN_FIRST_INDEX,
          item,
          items,
        })
    : removeRequestBoardColumnItem({ id, items })
}
